export function initVue() {
    // Initialize Light Gallery

    window.Vue = require("vue");

    //VUE Production Settings (comment out in dev)
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true

    /**
     * Next, we will create a fresh Vue application instance and attach it to
     * the page. Then, you may begin adding components to this application
     * or customize the JavaScript scaffolding to fit your unique needs.
     **/

    Vue.component(
        "component-archive",
        require("./components/ComponentArchive.vue")
    );
    Vue.component(
        "component-social",
        require("./components/ComponentSocial.vue")
    );
    Vue.component('pagination', require('laravel-vue-pagination'));

    $(document).ready(function() {
        if (document.querySelector("#app")) {
            const app = new Vue({
                el: "#app"
            });
        }
    });
}